import { Modal } from "@uhg-harmony/react";
import { useNotificationModalStore } from "../store/notificationModalStore";
import styled, { css } from 'styled-components';

export const SubHeading = styled.div`
  ${({ theme }) => css`
    font-family: ${theme.HarmonySemanticFontFamilyAction};

    line-height: ${theme.HarmonyAccordionLineHeightTitle};
    font-size: ${theme.HarmonySemanticFontSizeL};
    color: #000;
  `}
`;

export const Description = styled.div`
  ${({ theme }) => css`
    font-family: ${theme.HarmonySemanticFontFamilyAction};
    font-size: ${theme.HarmonySemanticFontSizeBase};
    font-weight: ${theme.HarmonySemanticFontWeightRegular};
    line-height: ${theme.HarmonySemanticLineHeightBody};
    color:  #000;
    margin-top: 8px;
     white-space: pre-wrap;       /* Preserves spaces but wraps lines naturally */
    word-wrap: break-word;       /* Alternative for older browsers */
    word-break: break-all; 
  `}
`;

const NotificationModal = () => {
  const { notification, showModal, closeModal } = useNotificationModalStore();

  if (!notification) return null;

  const data = JSON.stringify(notification, null, 2);

  return (
    <Modal
      open={showModal}
      onClose={closeModal}
      title="Notification Details"
      >
      <Modal.Body>
         <pre><Description>{data}</Description></pre>
      </Modal.Body>
    </Modal>
  );
};

export { NotificationModal };
